var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftRedemptionCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77352 34.0217C14.2489 38.0313 30.912 35.9033 34.6703 25.0842C38.4286 14.2651 34.5361 8.3739 26.0607 4.38673C17.5853 0.399563 8.76482 -3.29641 5.02569 7.52271C1.28657 18.3418 -2.70184 30.0345 5.77352 34.0217Z",
    fill: "#E1813D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4007 8.43248C28.903 2.38705 12.2284 0.258681 6.47048 9.85576C0.712545 19.4528 3.37385 26.1764 10.8759 32.2C18.3779 38.2236 26.273 44.0504 32.0122 34.4485C37.7515 24.8466 43.9027 14.4561 36.4007 8.43248Z",
    fill: "#E1813D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51221 27.1786V19.3322L19.623 11.5815L32.439 19.5751V27.1786L19.623 33.3193L7.51221 27.1786Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3535 11.1604C19.516 11.0564 19.7239 11.0552 19.8876 11.1573L32.7037 19.1508C32.8501 19.2421 32.939 19.4025 32.939 19.5751V27.1786C32.939 27.371 32.8286 27.5464 32.6551 27.6295L19.8391 33.7702C19.6989 33.8373 19.5355 33.8355 19.3969 33.7652L7.28609 27.6246C7.11808 27.5394 7.01221 27.367 7.01221 27.1786V19.3322C7.01221 19.1617 7.09908 19.0029 7.24269 18.911L19.3535 11.1604ZM19.6265 12.173L8.52576 19.2771L19.6335 24.7918L31.3797 19.5036L19.6265 12.173ZM31.939 20.3485L20.123 25.6681V32.5253L31.939 26.8637V20.3485ZM19.123 32.5051V25.6549L8.01221 20.1386V26.8715L19.123 32.5051Z",
    fill: "#33447C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1718 11.4546L11.1716 21.0959L19.6463 25.2416L28.831 21.0959V11.4546H11.1718Z",
    fill: "white",
    stroke: "#33447C",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0344 10.1085C9.54654 9.54987 9.3184 9.10192 8.74113 8.62914C8.5543 8.47614 8.04884 8.07951 7.81421 7.95068",
    stroke: "#33447C",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1825 9.3174C12.1728 8.49909 12.0086 7.68246 11.9221 6.86865",
    stroke: "#33447C",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69047 12.2827C9.17295 12.2827 8.61689 12.3365 8.09851 12.2773C8.00487 12.2666 7.12828 12.2322 7.08105 12.1377",
    stroke: "#33447C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftRedemptionCardIcon);
export default __webpack_public_path__ + "static/media/gift_redemption_card-icon.22083edd2653bc9498aafe2d141b1cd7.svg";
export { ForwardRef as ReactComponent };